export const AgreeOptions = {
  YES: 'Yes',
  NO: 'No',
};

export const AgreeOptionsCapitalized = {
  YES: 'YES',
  NO: 'NO',
};
